import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState('Browse Categories');

  return (
    <div className="relative w-full max-w-md mx-auto">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-3.5 bg-background-50 border border-background-200 rounded-xl text-foreground-800 text-sm font-medium hover:border-accent-300 transition-all duration-200 cursor-pointer"
      >
        <span>{selected}</span>
        <i className={`${open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-foreground-500`}></i>
      </button>

      {open && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200 rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.06)] max-h-72 overflow-y-auto z-30">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => {
                setSelected(cat.name);
                setOpen(false);
              }}
              className="block px-5 py-3 text-sm text-foreground-700 hover:bg-accent-50 hover:text-accent-700 transition-colors duration-150 cursor-pointer first:rounded-t-xl last:rounded-b-xl"
            >
              {cat.name}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}